export default __webpack_public_path__ + "static/B0190-3dda6d1c973c7ce64223725989d37b6d.png";